

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   CircularProgress,
//   Container,
//   Divider,
//   Grid,
//   IconButton,
//   List,
//   ListItem,
//   ListItemText,
//   Paper,
//   TextField,
//   Typography,
//   useTheme,
//   useMediaQuery,
//   Snackbar,
//   Alert,
//   Chip,
//   Avatar,
//   InputAdornment,
// } from "@mui/material";
// import {
//   Delete as DeleteIcon,
//   Search as SearchIcon,
//   Person as PersonIcon,
//   AccessTime as TimeIcon,
//   CalendarToday as CalendarIcon,
//   Group as GroupIcon,
//   Add as AddIcon,
//   CheckCircle as CheckCircleIcon,
//   Close as CloseIcon,
// } from "@mui/icons-material";

// const Addtimeslot = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const [selectedDoctor, setSelectedDoctor] = useState("");
//   const [query, setQuery] = useState("");
//   const [suggestions, setSuggestions] = useState([]);
//   const [formData, setFormData] = useState({
//     MT_SLOT_DATE: "",
//     MT_TIMESLOT: "",
//     MT_START_TIME: "",
//     MT_PATIENT_NO: 0,
//     MT_END_TIME: "",
//     MT_MAXIMUM_PATIENTS: "",
//     MT_DOCTOR: "Lakmal perera",
//     MT_ALLOCATED_TIME: "",
//     MT_USER_ID: "User029",
//   });
//   const [errorMessage, setErrorMessage] = useState("");
//   const [timeslotData, setTimeslotData] = useState([]);
//   const [validDoctorNames, setValidDoctorNames] = useState([]);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filteredTimeslots, setFilteredTimeslots] = useState([]);
//   const [isSearchActive, setIsSearchActive] = useState(false);

//   const showSnackbar = (message, severity = "success") => {
//     setSnackbarMessage(message);
//     setSnackbarSeverity(severity);
//     setSnackbarOpen(true);
//   };

//    const SINGLE_DOCTOR = {
//     UserName: "Lakmal perera", // Replace with actual doctor name
//     UserId: "User029" // Replace with actual doctor ID
//   };

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//    if (name === "MT_SLOT_DATE") {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       [name]: value, // The browser date input already returns yyyy-mm-dd
//     }));
//   } else {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       [name]: value,
//     }));
//   }
//   };

// const formatDate = (dateString) => {
//   if (!dateString) return '';
  
//   const date = new Date(dateString);
//   if (isNaN(date.getTime())) return dateString; // Return original if invalid
  
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const day = String(date.getDate()).padStart(2, '0');
  
//   return `${year}-${month}-${day}`;
// };

//   const handleSuggestionClick = (doctor) => {
//     setSelectedDoctor(doctor.UserName);
//     setQuery(doctor.UserName);
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       MT_DOCTOR: doctor.UserName,
//       MT_USER_ID: doctor.UserId,
//     }));
//     setSuggestions([]);
//     showSnackbar(`Doctor ${doctor.UserName} selected`, "success");
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     // const isValidDoctor = validDoctorNames.some(
//     //   (doctor) => doctor.UserName === formData.MT_DOCTOR
//     // );

//     // if (!isValidDoctor) {
//     //   setErrorMessage("Please select a doctor from the suggestions.");
//     //   showSnackbar("Please select a valid doctor", "error");
//     //   setLoading(false);
//     //   return;
//     // }

//     const adjustedFormData = {
//       ...formData,
//       MT_TIMESLOT: formData.MT_START_TIME + ":00",
//       MT_START_TIME: formData.MT_START_TIME + ":00",
//       MT_END_TIME: formData.MT_END_TIME + ":00",
//       MT_ALLOCATED_TIME: formData.MT_START_TIME + ":00",
//     };

//     try {
//       await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/Timeslot`,
//         adjustedFormData
//       );
//       showSnackbar("Timeslot added successfully!", "success");
//       setFormData({
//         MT_SLOT_DATE: "",
//         MT_TIMESLOT: "",
//         MT_START_TIME: "",
//         MT_PATIENT_NO: 0,
//         MT_END_TIME: "",
//         MT_MAXIMUM_PATIENTS: "",
//         MT_DOCTOR: "Lakmal perera",
//         MT_ALLOCATED_TIME: "",
//         MT_USER_ID: "User029",
//       });
//       setQuery("");
//       fetchTimeslots();
//     } catch (error) {
//       console.error(
//         "Failed to add timeslot",
//         error.response?.data || error.message
//       );
//       showSnackbar("Failed to add timeslot", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSearch = async (e) => {
//     const searchValue = e.target.value;
//     setQuery(searchValue);

//     if (searchValue.length > 2) {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/User/suggest?query=${searchValue}`
//         );
//         if (response.data.length === 0) {
//           setSuggestions([]);
//           setErrorMessage("No doctor registered with this name.");
//           setValidDoctorNames([]);
//         } else {
//           setSuggestions(response.data);
//           setValidDoctorNames(response.data);
//           setErrorMessage("");
//         }
//       } catch (error) {
//         console.error("Error fetching suggestions:", error);
//         setSuggestions([]);
//         setValidDoctorNames([]);
//         setErrorMessage("Error fetching doctor suggestions.");
//       }
//     } else {
//       setSuggestions([]);
//       setValidDoctorNames([]);
//       setErrorMessage("");
//     }
//   };

//   const fetchTimeslots = async () => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/Timeslot/active-timeslots`
//       );
//       setTimeslotData(response.data.reverse());
//       setFilteredTimeslots(response.data.reverse());
//     } catch (error) {
//       console.error("Error fetching timeslots:", error);
//       showSnackbar("Failed to load timeslots", "error");
//     }
//   };

//   const handleTimeslotSearchChange = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     setIsSearchActive(value.length > 0);

//     if (value.length === 0) {
//       setFilteredTimeslots(timeslotData);
//       return;
//     }

//     const filtered = timeslotData.filter((timeslot) => {
//       const searchLower = value.toLowerCase();
//       return (
//         timeslot.MT_DOCTOR.toLowerCase().includes(searchLower) ||
//         timeslot.MT_SLOT_DATE.toLowerCase().includes(searchLower)
//       );
//     });

//     setFilteredTimeslots(filtered);
//   };

//   const clearSearch = () => {
//     setSearchTerm("");
//     setIsSearchActive(false);
//     setFilteredTimeslots(timeslotData);
//   };

//   const Deletetime = async (id) => {
//     if (window.confirm("Are you sure you want to inactivate this timeslot?")) {
//       try {
//         await axios.put(
//           `${process.env.REACT_APP_API_BASE_URL}/Timeslot/update-status/${id}`
//         );
//         showSnackbar("Timeslot inactivated successfully", "success");
//         fetchTimeslots();
//       } catch (error) {
//         console.error(
//           "Error deleting timeslot:",
//           error.response?.data || error.message
//         );
//         showSnackbar("Failed to inactivate timeslot", "error");
//       }
//     }
//   };

//   const formatTime = (timeString) => {
//     return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
//   };

//   // useEffect(() => {
//   //   fetchTimeslots();
//   //   const interval = setInterval(fetchTimeslots, 60000);
//   //   return () => clearInterval(interval);
//   // }, []);
//     useEffect(() => {
//       const today = new Date();
//       const year = today.getFullYear();
//       const month = String(today.getMonth() + 1).padStart(2, '0');
//       const day = String(today.getDate()).padStart(2, '0');
//       const todayFormatted = `${year}-${month}-${day}`;
//       setFormData(prev => ({
//         ...prev,
//         MT_SLOT_DATE: todayFormatted, 
//         MT_DOCTOR: SINGLE_DOCTOR.UserName,
//         MT_USER_ID: SINGLE_DOCTOR.UserId
//       }));
//       setQuery(SINGLE_DOCTOR.UserName);
      
//       fetchTimeslots();
//       const interval = setInterval(fetchTimeslots, 60000);
//       return () => clearInterval(interval);
//     }, []);

//   return (
//     <Container maxWidth="xl" sx={{ py: 2 }}>
//       <Paper elevation={3} sx={{ p: 3 }}>
//         <Typography
//           variant="h4"
//           component="h1"
//           gutterBottom
//           color="primary"
//           fontWeight={600}
//           align="center"
//         >
//           Timeslot Management
//         </Typography>

//         <Grid container spacing={3}>
//           <Grid item xs={12} md={6} sx={{ ml: -2 }}>
//             <CardContent>
//               <Typography
//                 variant="h6"
//                 gutterBottom
//                 color="primary"
//                 fontWeight={600}
//               >
//                 Add New Timeslot
//               </Typography>

//               <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
//                 <Grid container spacing={2} alignItems="center">
//                   <Grid item xs={12} md={2.4}>
//                     <TextField
//                       fullWidth
//                       label="Date"
//                       type="date"
//                       name="MT_SLOT_DATE"
//                       value={formData.MT_SLOT_DATE}
//                       onChange={handleChange}
//                       required
//                       InputLabelProps={{ shrink: true }}
//                       InputProps={{
//                         startAdornment: (
//                           <InputAdornment position="start">
//                             <CalendarIcon sx={{ color: "primary.main" }} />
//                           </InputAdornment>
//                         ),
//                       }}
                    
//                                     />
//                   </Grid>

                  // <Grid item xs={12} md={2.4}>
                  //   <TextField
                  //     fullWidth
                  //     label="Start Time"
                  //     type="time"
                  //     name="MT_START_TIME"
                  //     value={formData.MT_START_TIME}
                  //     onChange={handleChange}
                  //     required
                  //     InputLabelProps={{ shrink: true }}
                  //     InputProps={{
                  //       startAdornment: (
                  //         <InputAdornment position="start">
                  //           <TimeIcon sx={{ color: "primary.main" }} />
                  //         </InputAdornment>
                  //       ),
                  //     }}
                  //   />
                  // </Grid>

                  // <Grid item xs={12} md={2.4}>
                  //   <TextField
                  //     fullWidth
                  //     label="End Time"
                  //     type="time"
                  //     name="MT_END_TIME"
                  //     value={formData.MT_END_TIME}
                  //     onChange={handleChange}
                  //     required
                  //     InputLabelProps={{ shrink: true }}
                  //     InputProps={{
                  //       startAdornment: (
                  //         <InputAdornment position="start">
                  //           <TimeIcon sx={{ color: "primary.main" }} />
                  //         </InputAdornment>
                  //       ),
                  //     }}
                  //   />
                  // </Grid>

//                   <Grid item xs={12} md={2.4}>
//                     <TextField
//                       fullWidth
//                       label="Max Patients"
//                       type="number"
//                       name="MT_MAXIMUM_PATIENTS"
//                       value={formData.MT_MAXIMUM_PATIENTS}
//                       onChange={handleChange}
//                       required
//                       InputProps={{
//                         startAdornment: (
//                           <InputAdornment position="start">
//                             <GroupIcon sx={{ color: "primary.main" }} />
//                           </InputAdornment>
//                         ),
//                         inputProps: { min: 1 },
//                       }}
//                     />
//                   </Grid>

//                   {/* <Grid item xs={12} md={2.4}>
//                     <Box sx={{ width: "95%" }}>
//                       <TextField
//                         fullWidth
//                         label="Search Doctor"
//                         placeholder="Search doctor by username"
//                         value={query}
//                         onChange={handleSearch}
//                         required
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <SearchIcon sx={{ color: "primary.main" }} />
//                             </InputAdornment>
//                           ),
//                         }}
//                       />
//                       {errorMessage && (
//                         <Typography color="error" variant="caption">
//                           {errorMessage}
//                         </Typography>
//                       )}
//                       {suggestions.length > 0 && (
//                         <Paper
//                           elevation={3}
//                           sx={{ mt: 1, maxHeight: 200, overflow: "auto" }}
//                         >
//                           <List dense>
//                             {suggestions.map((doctor) => (
//                               <ListItem
//                                 key={doctor.UserId}
//                                 button
//                                 onClick={() => handleSuggestionClick(doctor)}
//                                 sx={{
//                                   "&:hover": {
//                                     backgroundColor: theme.palette.action.hover,
//                                   },
//                                 }}
//                               >
//                                 <Avatar sx={{ mr: 2, bgcolor: "primary.main" }}>
//                                   <PersonIcon />
//                                 </Avatar>
//                                 <ListItemText
//                                   primary={doctor.UserName}
//                                   secondary={`ID: ${doctor.UserId}`}
//                                 />
//                               </ListItem>
//                             ))}
//                           </List>
//                         </Paper>
//                       )}
//                     </Box>
//                   </Grid> */}

//                    <Grid item xs={12} md={2.4}>
//                       <TextField
//                         fullWidth
//                         label="Doctor"
//                         value={SINGLE_DOCTOR.UserName}
//                         InputProps={{
//                           readOnly: true,
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <PersonIcon sx={{ color: "primary.main" }} />
//                             </InputAdornment>
//                           ),
//                         }}
//                         variant="outlined"
//                       />
//                     </Grid>

//                   <Grid item xs={12}>
//                     <Box display="flex" justifyContent="center">
//                       <Button
//                         variant="contained"
//                         type="submit"
//                         startIcon={<AddIcon />}
//                         disabled={loading}
//                         sx={{ py: 1.5, px: 4 }}
//                       >
//                         {loading ? (
//                           <CircularProgress size={24} color="inherit" />
//                         ) : (
//                           "Add Timeslot"
//                         )}
//                       </Button>
//                     </Box>
//                   </Grid>
//                 </Grid>
//               </Box>
//             </CardContent>
//           </Grid>

//           <Grid item xs={12} md={6} sx={{ ml: -2 ,mt:-3}}>
//             <CardContent>
//               <Typography
//                 variant="h6"
//                 gutterBottom
//                 color="primary"
//                 fontWeight={600}
//               >
//                 Available Timeslots
//               </Typography>

//               <Box sx={{ display: 'flex', gap: 2, mb: 3, position: 'relative', width: '92%' }}>
//                 <TextField
//                   fullWidth
//                   variant="outlined"
//                   placeholder="Search by doctor name or date (YYYY-MM-DD)"
//                   value={searchTerm}
//                   onChange={handleTimeslotSearchChange}
//                   InputProps={{
//                     startAdornment: (
//                       <SearchIcon sx={{ mr: 1, color: "primary.main" }} />
//                     ),
//                     endAdornment: isSearchActive && (
//                       <IconButton
//                         onClick={clearSearch}
//                         size="small"
//                         sx={{ visibility: searchTerm ? 'visible' : 'hidden' }}
//                       >
//                         <CloseIcon fontSize="small" />
//                       </IconButton>
//                     ),
//                   }}
//                 />
//               </Box>

//               {isSearchActive && (
//                 <Typography
//                   variant="h6"
//                   gutterBottom
//                   color="primary"
//                   fontWeight={600}
//                   sx={{ mb: 2 }}
//                 >
//                   Search Results
//                 </Typography>
//               )}

//               {filteredTimeslots.length > 0 ? (
//                 <Grid container spacing={2}>
//                   {filteredTimeslots.map((timeslot) => (
//                     <Grid item xs={12} key={timeslot.MT_SLOT_ID}>
//                       <Card
//                         variant="outlined"
//                         sx={{
//                           "&:hover": {
//                             boxShadow: 2,
//                             borderColor: theme.palette.primary.main,
//                           },
//                         }}
//                       >
//                         <CardContent>
//                           <Box
//                             sx={{
//                               display: "flex",
//                               justifyContent: "space-between",
//                               alignItems: "flex-start",
//                             }}
//                           >
//                             <Box>
//                               <Typography variant="subtitle1" gutterBottom>
//                                 <TimeIcon
//                                   fontSize="small"
//                                   sx={{
//                                     mr: 1,
//                                     verticalAlign: "middle",
//                                     color: "primary.main",
//                                   }}
//                                 />
//                                 {formatTime(timeslot.MT_START_TIME)} -{" "}
//                                 {formatTime(timeslot.MT_END_TIME)}
//                               </Typography>
//                               <Typography
//                                 variant="body2"
//                                 color="text.secondary"
//                               >
//                                 <CalendarIcon
//                                   fontSize="small"
//                                   sx={{
//                                     mr: 1,
//                                     verticalAlign: "middle",
//                                     color: "primary.main",
//                                   }}
//                                 />
//                                 {timeslot.MT_SLOT_DATE.split("T")[0]}
//                               </Typography>
//                               <Typography variant="body2" sx={{ mt: 1 }}>
//                                 <PersonIcon
//                                   fontSize="small"
//                                   sx={{
//                                     mr: 1,
//                                     verticalAlign: "middle",
//                                     color: "primary.main",
//                                   }}
//                                 />
//                                 Dr. {timeslot.MT_DOCTOR}
//                               </Typography>
//                               <Chip
//                                 label={`Max Patients: ${timeslot.MT_MAXIMUM_PATIENTS}`}
//                                 size="small"
//                                 sx={{ mt: 1 }}
//                               />
//                             </Box>
//                             <IconButton
//                               color="error"
//                               onClick={() => Deletetime(timeslot.MT_SLOT_ID)}
//                               aria-label="delete"
//                             >
//                               <DeleteIcon />
//                             </IconButton>
//                           </Box>
//                         </CardContent>
//                       </Card>
//                     </Grid>
//                   ))}
//                 </Grid>
//               ) : (
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     p: 3,
//                     textAlign: "center",
//                     backgroundColor: theme.palette.grey[100],
//                   }}
//                 >
//                   <Typography variant="body1" color="text.secondary">
//                     {isSearchActive
//                       ? "No matching timeslots found"
//                       : "No available timeslots found"}
//                   </Typography>
//                 </Paper>
//               )}
//             </CardContent>
//           </Grid>
//         </Grid>

//         <Snackbar
//           open={snackbarOpen}
//           autoHideDuration={6000}
//           onClose={handleSnackbarClose}
//           anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         >
//           <Alert
//             onClose={handleSnackbarClose}
//             severity={snackbarSeverity}
//             sx={{ width: "100%" }}
//           >
//             {snackbarMessage}
//           </Alert>
//         </Snackbar>
//       </Paper>
//     </Container>
//   );
// };

// export default Addtimeslot;
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  TextField,
  Typography,
  useTheme,
  useMediaQuery,
  Snackbar,
  Alert,
  Chip,
  Avatar,
  InputAdornment,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  Search as SearchIcon,
  Person as PersonIcon,
  AccessTime as TimeIcon,
  CalendarToday as CalendarIcon,
  Group as GroupIcon,
  Add as AddIcon,
  CheckCircle as CheckCircleIcon,
  Close as CloseIcon,
  Warning as WarningIcon,
} from "@mui/icons-material";

const Addtimeslot = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [formData, setFormData] = useState({
    MT_SLOT_DATE: "",
    MT_TIMESLOT: "",
    MT_START_TIME: "",
    MT_PATIENT_NO: 0,
    MT_END_TIME: "",
    MT_MAXIMUM_PATIENTS: "",
    MT_DOCTOR: "",
    MT_ALLOCATED_TIME: "",
    MT_USER_ID: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [timeslotData, setTimeslotData] = useState([]);
  const [validDoctorNames, setValidDoctorNames] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredTimeslots, setFilteredTimeslots] = useState([]);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [dateError, setDateError] = useState("");
  const [timeError, setTimeError] = useState("");

  const showSnackbar = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const SINGLE_DOCTOR = {
    UserName: "Primali Perera ",
    UserId: "User031"
  };

  const MAX_FUTURE_DAYS = 90; // Maximum days in advance to schedule
  //const MIN_BOOKING_HOURS = 2; // Minimum hours before appointment

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  // Get today's date in YYYY-MM-DD format
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  // Get maximum allowed date
  const getMaxDate = () => {
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + MAX_FUTURE_DAYS);
    return maxDate.toISOString().split('T')[0];
  };

  // Validate date is within allowed range
  const validateDate = (selectedDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const selected = new Date(selectedDate);
    selected.setHours(0, 0, 0, 0);
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + MAX_FUTURE_DAYS);
    maxDate.setHours(0, 0, 0, 0);

    if (selected < today) {
      setDateError("Cannot schedule timeslots for past dates");
      return false;
    }

    if (selected > maxDate) {
      setDateError(`Cannot schedule more than ${MAX_FUTURE_DAYS} days in advance`);
      return false;
    }

    // If date is today, check if time allows minimum booking hours
    if (selected.getTime() === today.getTime()) {
      setDateError(""); // Will validate time separately
      return true;
    }

    setDateError("");
    return true;
  };

  // Validate time for today's appointments
  const validateTimeForToday = (selectedDate, startTime) => {
    const today = new Date();
    const selected = new Date(selectedDate);
    
    // if (selected.toDateString() === today.toDateString()) {
    //   const [hours, minutes] = startTime.split(':');
    //   const appointmentTime = new Date();
    //   appointmentTime.setHours(parseInt(hours), parseInt(minutes), 0, 0);
      
    //   const minTime = new Date();
    //   minTime.setHours(minTime.getHours() + MIN_BOOKING_HOURS);
      
    //   if (appointmentTime < minTime) {
    //     setTimeError(`Appointments must be at least ${MIN_BOOKING_HOURS} hours from now`);
    //     return false;
    //   }
    // }
    
    setTimeError("");
    return true;
  };

  // Validate start time is before end time
  const validateTimeRange = (startTime, endTime) => {
    if (!startTime || !endTime) return true;

    const [startHours, startMinutes] = startTime.split(':').map(Number);
    const [endHours, endMinutes] = endTime.split(':').map(Number);
    
    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;

    if (startTotalMinutes >= endTotalMinutes) {
      setTimeError("End time must be after start time");
      return false;
    }

    setTimeError("");
    return true;
  };

  // Check for overlapping timeslots
  const checkOverlappingTimeslots = (date, startTime, endTime, doctorId) => {
    const existingSlots = timeslotData.filter(
      slot => slot.MT_SLOT_DATE.split('T')[0] === date && slot.MT_USER_ID === doctorId
    );

    const [newStartHours, newStartMinutes] = startTime.split(':').map(Number);
    const [newEndHours, newEndMinutes] = endTime.split(':').map(Number);
    const newStart = newStartHours * 60 + newStartMinutes;
    const newEnd = newEndHours * 60 + newEndMinutes;

    for (const slot of existingSlots) {
      const slotStart = slot.MT_START_TIME.split(':').slice(0, 2);
      const slotEnd = slot.MT_END_TIME.split(':').slice(0, 2);
      const existingStart = parseInt(slotStart[0]) * 60 + parseInt(slotStart[1]);
      const existingEnd = parseInt(slotEnd[0]) * 60 + parseInt(slotEnd[1]);

      // Check for overlap
      if (
        (newStart >= existingStart && newStart < existingEnd) ||
        (newEnd > existingStart && newEnd <= existingEnd) ||
        (newStart <= existingStart && newEnd >= existingEnd)
      ) {
        return true;
      }
    }

    return false;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "MT_SLOT_DATE") {
      validateDate(value);
      if (formData.MT_START_TIME) {
        validateTimeForToday(value, formData.MT_START_TIME);
      }
    }

    if (name === "MT_START_TIME") {
      if (formData.MT_SLOT_DATE) {
        validateTimeForToday(formData.MT_SLOT_DATE, value);
      }
      if (formData.MT_END_TIME) {
        validateTimeRange(value, formData.MT_END_TIME);
      }
    }

    if (name === "MT_END_TIME") {
      if (formData.MT_START_TIME) {
        validateTimeRange(formData.MT_START_TIME, value);
      }
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSuggestionClick = (doctor) => {
    setSelectedDoctor(doctor.UserName);
    setQuery(doctor.UserName);
    setFormData((prevFormData) => ({
      ...prevFormData,
      MT_DOCTOR: doctor.UserName,
      MT_USER_ID: doctor.UserId,
    }));
    setSuggestions([]);
    showSnackbar(`Stylist ${doctor.UserName} selected`, "success");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Validate date
    if (!validateDate(formData.MT_SLOT_DATE)) {
      setLoading(false);
      showSnackbar(dateError, "error");
      return;
    }

    // Validate time for today
    if (!validateTimeForToday(formData.MT_SLOT_DATE, formData.MT_START_TIME)) {
      setLoading(false);
      showSnackbar(timeError, "error");
      return;
    }

    // Validate time range
    if (!validateTimeRange(formData.MT_START_TIME, formData.MT_END_TIME)) {
      setLoading(false);
      showSnackbar(timeError, "error");
      return;
    }

    // Check for overlapping timeslots
    if (checkOverlappingTimeslots(
      formData.MT_SLOT_DATE,
      formData.MT_START_TIME,
      formData.MT_END_TIME,
      formData.MT_USER_ID
    )) {
      setLoading(false);
      showSnackbar("This timeslot overlaps with an existing appointment", "error");
      return;
    }

    const adjustedFormData = {
      ...formData,
      MT_TIMESLOT: formData.MT_START_TIME + ":00",
      MT_START_TIME: formData.MT_START_TIME + ":00",
      MT_END_TIME: formData.MT_END_TIME + ":00",
      MT_ALLOCATED_TIME: formData.MT_START_TIME + ":00",
    };

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/Timeslot`,
        adjustedFormData
      );
      showSnackbar("Timeslot added successfully!", "success");
      setFormData({
        MT_SLOT_DATE: "",
        MT_TIMESLOT: "",
        MT_START_TIME: "",
        MT_PATIENT_NO: 0,
        MT_END_TIME: "",
        MT_MAXIMUM_PATIENTS: "",
        MT_DOCTOR: SINGLE_DOCTOR.UserName,
        MT_ALLOCATED_TIME: "",
        MT_USER_ID: SINGLE_DOCTOR.UserId,
      });
      setQuery(SINGLE_DOCTOR.UserName);
      setDateError("");
      setTimeError("");
      fetchTimeslots();
    } catch (error) {
      console.error(
        "Failed to add timeslot",
        error.response?.data || error.message
      );
      showSnackbar("Failed to add timeslot", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setQuery(searchValue);

    if (searchValue.length > 2) {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/User/suggest?query=${searchValue}`
        );
        if (response.data.length === 0) {
          setSuggestions([]);
          setErrorMessage("No Stylist registered with this name.");
          setValidDoctorNames([]);
        } else {
          setSuggestions(response.data);
          setValidDoctorNames(response.data);
          setErrorMessage("");
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setSuggestions([]);
        setValidDoctorNames([]);
        setErrorMessage("Error fetching Stylist suggestions.");
      }
    } else {
      setSuggestions([]);
      setValidDoctorNames([]);
      setErrorMessage("");
    }
  };

  const fetchTimeslots = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/Timeslot/active-timeslots`
      );
      setTimeslotData(response.data.reverse());
      setFilteredTimeslots(response.data.reverse());
    } catch (error) {
      console.error("Error fetching timeslots:", error);
      showSnackbar("Failed to load timeslots", "error");
    }
  };

  const handleTimeslotSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setIsSearchActive(value.length > 0);

    if (value.length === 0) {
      setFilteredTimeslots(timeslotData);
      return;
    }

    const filtered = timeslotData.filter((timeslot) => {
      const searchLower = value.toLowerCase();
      return (
        timeslot.MT_DOCTOR.toLowerCase().includes(searchLower) ||
        timeslot.MT_SLOT_DATE.toLowerCase().includes(searchLower)
      );
    });

    setFilteredTimeslots(filtered);
  };

  const clearSearch = () => {
    setSearchTerm("");
    setIsSearchActive(false);
    setFilteredTimeslots(timeslotData);
  };

  const Deletetime = async (id) => {
    if (window.confirm("Are you sure you want to inactivate this timeslot?")) {
      try {
        await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/Timeslot/update-status/${id}`
        );
        showSnackbar("Timeslot inactivated successfully", "success");
        fetchTimeslots();
      } catch (error) {
        console.error(
          "Error deleting timeslot:",
          error.response?.data || error.message
        );
        showSnackbar("Failed to inactivate timeslot", "error");
      }
    }
  };

  const formatTime = (timeString) => {
    return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      MT_DOCTOR: SINGLE_DOCTOR.UserName,
      MT_USER_ID: SINGLE_DOCTOR.UserId
    }));
    setQuery(SINGLE_DOCTOR.UserName);
    
    fetchTimeslots();
    const interval = setInterval(fetchTimeslots, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          color="primary"
          fontWeight={600}
          align="center"
        >
          Timeslot Management
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6} sx={{ ml: -2 }}>
            <CardContent>
              <Typography
                variant="h6"
                gutterBottom
                color="primary"
                fontWeight={600}
              >
                Add New Timeslot
              </Typography>

              <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={2.4}>
                    <TextField
                      fullWidth
                      label="Date"
                      type="date"
                      name="MT_SLOT_DATE"
                      value={formData.MT_SLOT_DATE}
                      onChange={handleChange}
                      required
                      error={!!dateError}
                      helperText={dateError}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        placeholder: "YYYY/MM/DD"
                      }}
                      sx={{
                        '& .MuiInputBase-input': {
                          position: 'relative',
                          backgroundColor: 'transparent',
                        },
                        '& input[type="date"]': {
                          color: 'transparent',
                          position: 'relative',
                          '&::-webkit-calendar-picker-indicator': {
                            opacity: 0,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            width: '100%',
                            height: '100%',
                            cursor: 'pointer',
                            zIndex: 2,
                          },
                        },
                        '& .MuiInputBase-root': {
                          position: 'relative',
                          '&::after': {
                            content: formData.MT_SLOT_DATE
                              ? `"${formData.MT_SLOT_DATE.split('-').join('/')}"`
                              : '"YYYY/MM/DD"',
                            position: 'absolute',
                            left: '40px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: formData.MT_SLOT_DATE ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.6)',
                            fontSize: '14px',
                            fontFamily: 'inherit',
                            pointerEvents: 'none',
                            zIndex: 1,
                          }
                        }
                      }}
                     
                    />
                  </Grid>

                  <Grid item xs={12} md={2.4}>
                    <TextField
                      fullWidth
                      label="Start Time"
                      type="time"
                      name="MT_START_TIME"
                      value={formData.MT_START_TIME}
                      onChange={handleChange}
                      required
                      error={!!timeError}
                      helperText={timeError}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <TimeIcon sx={{ color: "primary.main" }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={2.4}>
                    <TextField
                      fullWidth
                      label="End Time"
                      type="time"
                      name="MT_END_TIME"
                      value={formData.MT_END_TIME}
                      onChange={handleChange}
                      required
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <TimeIcon sx={{ color: "primary.main" }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={2.4}>
                    <TextField
                      fullWidth
                      label="Max Customer"
                      type="number"
                      name="MT_MAXIMUM_PATIENTS"
                      value={formData.MT_MAXIMUM_PATIENTS}
                      onChange={handleChange}
                      required
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <GroupIcon sx={{ color: "primary.main" }} />
                          </InputAdornment>
                        ),
                        inputProps: { min: 1 },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={2.4}>
                    <TextField
                      fullWidth
                      label="Stylist"
                      value={SINGLE_DOCTOR.UserName}
                      InputProps={{
                        readOnly: true,
                        startAdornment: (
                          <InputAdornment position="start">
                            <PersonIcon sx={{ color: "primary.main" }} />
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Box display="flex" justifyContent="center">
                      <Button
                        variant="contained"
                        type="submit"
                        startIcon={<AddIcon />}
                        disabled={loading || !!dateError || !!timeError}
                        sx={{ py: 1.5, px: 4 }}
                      >
                        {loading ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          "Add Timeslot"
                        )}
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Grid>

          <Grid item xs={12} md={6} sx={{ ml: -2, mt: -3 }}>
            <CardContent>
              <Typography
                variant="h6"
                gutterBottom
                color="primary"
                fontWeight={600}
              >
                Available Timeslots
              </Typography>

              <Box sx={{ display: 'flex', gap: 2, mb: 3, position: 'relative', width: '92%' }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Search Date (YYYY-MM-DD)"
                  value={searchTerm}
                  onChange={handleTimeslotSearchChange}
                  InputProps={{
                    startAdornment: (
                      <SearchIcon sx={{ mr: 1, color: "primary.main" }} />
                    ),
                    endAdornment: isSearchActive && (
                      <IconButton
                        onClick={clearSearch}
                        size="small"
                        sx={{ visibility: searchTerm ? 'visible' : 'hidden' }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    ),
                  }}
                />
              </Box>

              {isSearchActive && (
                <Typography
                  variant="h6"
                  gutterBottom
                  color="primary"
                  fontWeight={600}
                  sx={{ mb: 2 }}
                >
                  Search Results
                </Typography>
              )}

              {filteredTimeslots.length > 0 ? (
                <Grid container spacing={2}>
                  {filteredTimeslots.map((timeslot) => (
                    <Grid item xs={12} key={timeslot.MT_SLOT_ID}>
                      <Card
                        variant="outlined"
                        sx={{
                          "&:hover": {
                            boxShadow: 2,
                            borderColor: theme.palette.primary.main,
                          },
                        }}
                      >
                        <CardContent>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "flex-start",
                            }}
                          >
                            <Box>
                              <Typography variant="subtitle1" gutterBottom>
                                <TimeIcon
                                  fontSize="small"
                                  sx={{
                                    mr: 1,
                                    verticalAlign: "middle",
                                    color: "primary.main",
                                  }}
                                />
                                {formatTime(timeslot.MT_START_TIME)} -{" "}
                                {formatTime(timeslot.MT_END_TIME)}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                <CalendarIcon
                                  fontSize="small"
                                  sx={{
                                    mr: 1,
                                    verticalAlign: "middle",
                                    color: "primary.main",
                                  }}
                                />
                                {timeslot.MT_SLOT_DATE.split("T")[0]}
                              </Typography>
                              <Typography variant="body2" sx={{ mt: 1 }}>
                                <PersonIcon
                                  fontSize="small"
                                  sx={{
                                    mr: 1,
                                    verticalAlign: "middle",
                                    color: "primary.main",
                                  }}
                                />
                                {timeslot.MT_DOCTOR}
                              </Typography>
                              <Chip
                                label={`Max Customer: ${timeslot.MT_MAXIMUM_PATIENTS}`}
                                size="small"
                                sx={{ mt: 1 }}
                              />
                            </Box>
                            <IconButton
                              color="error"
                              onClick={() => Deletetime(timeslot.MT_SLOT_ID)}
                              aria-label="delete"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    textAlign: "center",
                    backgroundColor: theme.palette.grey[100],
                  }}
                >
                  <Typography variant="body1" color="text.secondary">
                    {isSearchActive
                      ? "No matching timeslots found"
                      : "No available timeslots found"}
                  </Typography>
                </Paper>
              )}
            </CardContent>
          </Grid>
        </Grid>

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Paper>
    </Container>
  );
};

export default Addtimeslot;